module.exports = __webpack_public_path__ + "static/media/calendar.c9cb7de4.svg";